'use strict';

import Vue from 'vue/dist/vue.common.js';

// components
import Favorites from '../components/favorites'

// vuex
import store from '../vuex/store';

let DirectoryHeader = Vue.extend({
  store,
  components: {
    Favorites
  },
  computed: {
    userName() { return this.$store.getters.userName; },
    loggedIn() { return this.$store.state.loggedIn; },
  }
});

export default DirectoryHeader;



// WEBPACK FOOTER //
// ./app/javascript/vue/instances/directory-header.js